// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"goTop_root__HfzR2","scrollTop":"goTop_scrollTop__bTwo9"};